/**
 * import main Fashion Slider function
 */
import createFashionSlider from './fashion-slider';
/**
 * import Fashion Slider styles
 */
import '../styles/block-header-carousel.scss';

/**
 * Fashion Slider element
 */
const sliderEl = document.querySelector('.fashion-slider');

/**
 * Init Fashion Slider
 *
 * argument: pass .fashion-slider element
 */
createFashionSlider(sliderEl);



// WEBPACK FOOTER //
// ./scripts/block-header-carousel.js